import { render, staticRenderFns } from "./JobSpools.vue?vue&type=template&id=476b5fba&"
import script from "./JobSpools.vue?vue&type=script&lang=js&"
export * from "./JobSpools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports